const GET_MENUS_REQUEST = 'GET_MENUS_REQUEST';
const GET_MENUS_SUCCESS = 'GET_MENUS_SUCCESS';
const GET_MENUS_FAILURE = 'GET_MENUS_FAILURE';
const COPY_MENU_REQUEST = 'COPY_MENU_REQUEST';
const COPY_MENU_SUCCESS = 'COPY_MENU_SUCCESS';
const COPY_MENU_FAILURE = 'COPY_MENU_FAILURE';
const ARCHIVE_MENU_REQUEST = 'ARCHIVE_MENU_REQUEST';
const ARCHIVE_MENU_SUCCESS = 'ARCHIVE_MENU_SUCCESS';
const ARCHIVE_MENU_FAILURE = 'ARCHIVE_MENU_FAILURE';
const PRINT_MENUS_FOR_CURRENT_MONTH = 'PRINT_MENUS_FOR_CURRENT_MONTH';

export default {
  GET_MENUS_REQUEST,
  GET_MENUS_SUCCESS,
  GET_MENUS_FAILURE,
  COPY_MENU_REQUEST,
  COPY_MENU_SUCCESS,
  COPY_MENU_FAILURE,
  ARCHIVE_MENU_REQUEST,
  ARCHIVE_MENU_SUCCESS,
  ARCHIVE_MENU_FAILURE,
  PRINT_MENUS_FOR_CURRENT_MONTH
};
